import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogoFacilityComponent } from 'src/app/shared/components/logo-facility/logo.component';
import { InvalidFieldComponent } from '../../../components';
import { DisableControlDirective } from '../../../directives/disable-control.directive';
import { FacilityLocationsModule } from '../../facility-locations/facility-locations.module';
import { FlightNumberSearchMaterialModule } from './flight-number-search-material-modules.module';
import { FlightNumberSearchComponent } from './flight-number-search.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        LogoFacilityComponent,
        FlightNumberSearchMaterialModule,
        InvalidFieldComponent,
        FacilityLocationsModule,
        DisableControlDirective,
    ],
    declarations: [FlightNumberSearchComponent],
    exports: [FlightNumberSearchComponent],
})
export class FlightNumberSearchModule {}
